<template>
  <!-- 互动生成 生成人群 -->
  <div class="bigbox">
    <el-dialog :visible.sync="isShowCrowdDialog" title="生成人群" width="630px" :before-close="close">
      <el-form :model="crowdForm" label-width="130px" class="demo-ruleForm new-input-box">
        <el-form-item label="人群名称：" prop="name" required>
          <el-input v-model="crowdForm.name" placeholder="请输入" maxlength="50" show-word-limit style="width: 400px;"></el-input>
        </el-form-item>
        <el-form-item label="人群描述：" prop="description" required>
          <el-input v-model="crowdForm.description" placeholder="请输入" maxlength="50" show-word-limit style="width: 400px;"></el-input>
        </el-form-item>
        <el-form-item label="生成人群类型：" prop="description" required>
          <!-- <el-checkbox-group v-model="crowdType"> -->
            <el-checkbox v-model="crowdForm.isBuildJdCrowd">生成京东人群</el-checkbox>
            <el-checkbox v-model="crowdForm.isBuildHdCrowd">生成云起人群</el-checkbox>
          <!-- </el-checkbox-group> -->
        </el-form-item>
      </el-form>
      <div style="width: 400px;margin-left: 130px;margin-top: -12px;">
        <div class="tip-page-box">
          <div class="left-tip-icon-box">
            <div class="left-tip">
              <img src="@/assets/images/new_icon_reminder.png">
            </div>
          </div>
          <div class="right-tip-box">
            <div>
              <p>1.京东人群营销场景：短信、富信、卡片短信及咚咚专享客户触达；</p>
              <p>2.云起人群营销场景：用于批量发放权益中快捷选择人群、互动活动中指定人群等场景。如需进行短信、富信、卡片短信及咚咚专享客户触达需先进行转化为京东人群。</p>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align:right;margin-top:20px;">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" style="margin-right: 8px" @click='save(2)' v-loading='btnLoading'>确认生成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { generateCrowBySearch } from "@/api/integralCenter/PointActivityAnalyticController";
export default {
  name: "crowd-dialog",
  props: {
    isShowCrowdDialog: {
      type: Boolean,
      default: false,
    },
    searchForm: {
      type: Object,
      default: {},
    },
    activityType:{
      type: Number | String
    },
    source:{
      type: Number | String
    },
    // 输入框的默认值
    defaultValue:{
      type: Boolean,
      default: false,
    },
    defaultValueText:{
      type: String,
      default: '',
    },
    // 兑换明细-按查询结果生成人群-flase
    hasSource:{
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      crowdForm: {
        name: '',
        description: '',
        isBuildJdCrowd: false,
        isBuildHdCrowd: false,
      },
      crowdType: [],
      btnLoading: false,
    };
  },
  created() {
    if(this.defaultValue){
      this.crowdForm.name = this.defaultValueText + this.getFormatDate()
      this.crowdForm.description = this.defaultValueText + this.getFormatDate()
    }
  },
  methods: {
    save(type) {
      let form = {...this.searchForm,activityType: this.activityType}
      form.activityId = form.activityId - 0
      form.hdSource = this.source
      if(!this.crowdForm.name) {
        return this.$message.warning('请输入人群名称')
      }else if(!this.crowdForm.description) {
        return this.$message.warning('请输入人群描述')
      }
      if(!this.crowdForm.isBuildJdCrowd && !this.crowdForm.isBuildHdCrowd) return this.$message.warning('请选择生成人群类型！')
      let obj = {
        ...this.crowdForm,
        condition: JSON.stringify(form)
      }
      if(!this.hasSource){
        obj.source = 7
      }else{
        obj.source = 9
      }
      // 晒单有礼-用户资料
      if(this.activityType==41)  obj.source = 7;
      this.btnLoading = true
      // if(this.crowdType.includes(0)){
      //   generateCrowBySearch({...obj, createCrowdType: 0}).then(res=>{
      //     this.btnLoading = false
      //     if(res.code == 1) {
      //       this.$message.success(res.message)
      //       this.$emit('close',false)
      //       if(type == 1) {
      //         this.$router.push({name:'accurate_market'})
      //       }
      //     }else{
      //       this.$message.error(res.message)
      //     }
      //   }).catch(err=>{
      //     this.btnLoading = false
      //   })
      // }
      // if(this.crowdType.includes(1)){
        generateCrowBySearch({...obj}).then(res=>{
          this.btnLoading = false
          if(res.code == 1) {
            this.$message.success(res.message)
            this.$emit('close',false)
            if(type == 1) {
              this.$router.push({name:'accurate_market'})
            }
          }else{
            this.$message.error(res.message)
          }
        }).catch(err=>{
          this.btnLoading = false
        })
      // }
    },
    close(){
      this.$emit('close',false)
    },
    getFormatDate() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();
      month = (month < 10) ? '0' + month : month;
      day = (day < 10) ? '0' + day : day;
      hour = (hour < 10) ? '0' + hour : hour;
      minutes = (minutes < 10) ? '0' + minutes : minutes;
      seconds = (seconds < 10) ? '0' + seconds : seconds;
      let currentDate = year + "-" + month + "-" + day
        + " " + hour + ":" + minutes + ":" + seconds;
      return currentDate;
    },
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__error{
  display: none;
}
.tip-page-box {
  width: 100%;
  padding: 9px 14px;
  border-radius: 2px;
  background: #f4f7ff;
  .left-tip-icon-box {
    width: 16.25px;
    height: 22px;
    margin-right: 10px;
    float: left;
    display: flex;
    justify-items: center;
    align-items: center;
    .left-tip {
      width: 16.25px;
      height: 16.25px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .right-tip-box {
    display: inline-block;
    width: calc(100% - 30px);
    color: #666666;
    font-size: 12px;
    line-height: 22px;
  }
}
</style>
